import { http } from "./http";

export const getSamplePoints = async (params) => {
  const {
    unit_type,
    viscosity,
    sampleType,
    measurementUnit,
    radialBearingLoad,
    gearwheelSet,
    valveSystem,
  } = params;

  const queryParams = new URLSearchParams({
    unitType: unit_type,
    viscosity,
    sampleType,
    measurementUnit,
  });

  if (radialBearingLoad) {
    queryParams.append("radialBearingLoad", radialBearingLoad);
  }

  if (gearwheelSet) {
    queryParams.append("gearwheelSet", gearwheelSet);
  }

  if (valveSystem) {
    queryParams.append("valveSystem", valveSystem);
  }

  return http.get(`/sample-points?${queryParams.toString()}`);
};


export const getEfficiencyMatrix = async ({
  series,
  displacement,
  viscosity,
  measurementUnit,
}) =>
  http.get(
    `/motor-efficiency-points?series=${series}&displacement=${displacement}&viscosity=${viscosity}&measurementUnit=${measurementUnit}`
  );

export const motorEfficiencyWithParams = async ({ data }) => {
  try {
    const resizeBy = await http.post(`/relevant-motors`, data);
    return resizeBy;
  } catch (err) {
    console.error("Error in motorEfficiencyWithParams:", err);
    throw err;
  }
};
